export default () => ({
  type: 'function',
  processor: 'mustache',
  provider: () => `
<div>
  <p class="text-weight-bold q-mt-lg">
    <span data-jcs-element="info__journey__action" class="info-item__value">...</span>
  </p>
  <div class="q-mb-md">
    <p class="q-mt-sm">Before you start, please make sure:</p>
    <p class="q-mt-sm">1) Your driver's licence is up to date</p>
    <p class="q-mt-sm">2) Take photo in a well-lit flat surface</p>    
  </div>
  
  <!-- UI for displaying the camera selection -->
  <form class="q-mb-md">
    <select data-jcs-element="camera__select" class="control--select"></select>
  </form>
  
  <!-- Dashed primary container -->
  <div class="bdr-a-primary bdr-dashed bg-primary-pale rounded-borders-lg q-pa-sm">
    <!-- UI for displaying the camera view finder -->
    <div class="help-container relative-position">
      <div class="mx-h rounded-borders-lg relative-position">
        <div data-jcs-element="camera__viewfinder__inner__container" class="rounded-borders-lg relative-position">
          <canvas data-jcs-element="camera__viewfinder" class="camera-viewfinder relative-position" style="left: 0; top: 0; z-index: 0;"></canvas>
          <div data-jcs-element="animation__viewfinder" class="camera-viewfinder" style="position: absolute; left: 0; top: 0; z-index: 1;"></div>
          <div class="camera-viewfinder--overlay--transparent">
            <div class="loading-animation-container" data-jcs-element="loading-animation" style="display:none"></div>
            <div class="verifying-title-container" data-jcs-element="verifying__title" style="display:none">{{VERIFYING_TITLE}}</div>
          </div>
          <div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay"></div>
          <div class="camera-viewfinder--overlay--transparent">
            <p class="camera-viewfinder--overlay-text">
              <button data-jcs-element="camera__capture" class="button bg-primary text-white text-weight-medium">
                {{CAMERA_CAPTURE_START_BUTTON}}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
      
    <!-- Message for uploading -->
    <div class="uploading--container">
      <span data-jcs-element="camera__condition__uploading" class="camera-condition camera-condition--uploading">
        {{CAMERA_CONDITION_UPLOADING}}
      </span>
    </div>
    
    <!-- Message for failed capture conditions -->
    <div data-jcs-element="camera__conditions">
      <div class="column items-center full-width" data-jcs-element="camera__condition__detail">
        <div class="row items-center bdr-a-warning rounded-borders q-mt-md q-pa-sm q-mb-sm q-gutter-x-sm">
          <i class="eva eva-alert-circle-outline text-warning text-h5"></i>
          <span data-jcs-element="camera__condition__detail__description__title"></span>          
        </div>
        <div data-jcs-element="camera__condition__detail__description__hint"></div>
      </div>
    </div>

    <!-- Message for action instructions -->
    <div data-jcs-element="info__journey__action__container" class="q-my-md text-weight-medium text-center">
      <span data-jcs-element="info__journey__action__text"></span>
    </div>
  </div>

  <!-- UI for switching to manual capture -->
  <div class="q-mt-md" data-jcs-element="camera__manual__capture">
    <label class="bg-application-primary button text-weight-medium full-width" aria-label="switch">
      <input hidden type="checkbox" data-jcs-element="camera__manual__capture__check"/>
      <i class="eva eva-camera-outline text-white text-h5 q-mr-sm"></i>
      <p class="text-white text-weight-medium">Take a photo with your device</p>
    </label>
    
    <div class="row justify-center items-center full-width relative-position or-container q-mt-lg">
      <div class="or-container-line"></div>
      <p class="q-px-md text-grey-6">OR</p>
      <div class="or-container-line"></div>
    </div>
  </div>
</div>
  `
});
